import React from "react";

import { useErrorHandler } from "../hooks/useErrorHandler";
import { telemetryChannelName } from "../util/constants";
import { BuildTelemetryEvent, TelemetryListener } from "./Telemetry";
import TelemetryModel from "./TelemetryModel";
import { createTelemetryPayload } from "./TelemetryUtils";

export const TelemetryLayer = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const { throwError } = useErrorHandler();

  const onEvent = async (event: BuildTelemetryEvent): Promise<void> => {
    const {
      payload: { action, feature, action_meta, ...additionalProps },
    } = event;

    // Ensure required values are strings
    if (typeof action !== "string" || typeof feature !== "string") {
      return;
    }

    // Use the utility function to create the telemetry payload
    const telemetryPayload = createTelemetryPayload({
      feature,
      action,
      action_meta: typeof action_meta === "string" ? action_meta : "",
      ...additionalProps,
    });

    if (!telemetryPayload) {
      return;
    }

    try {
      await TelemetryModel(telemetryPayload).save();
    } catch (error) {
      throwError(error as Error);
    }
  };

  return (
    <TelemetryListener channel={telemetryChannelName} onEvent={onEvent}>
      {children}
    </TelemetryListener>
  );
};
